import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import {FirstColumnHeaderStyle, TableHeaderStyle, FirstColumnFlexStyle, FlexColumnStyle} from './Table.styled';
import {TableHeaderGrouping} from './';
import {LayoutContext} from './table';

export const TableHeader = ({children, backgroundColor, stickyOffset}) => {
	const layout = useContext(LayoutContext);

	// seperate column index - children can be groupings or columns, so we need to keep a seperate index indstead of the children array index
	let columnIndex = 0;
	const newChildren = React.Children.map(children, child => {
		if (child.type === TableHeaderGrouping) {
			let newProps = {usePadding: true, level: columnIndex === 0 ? 1 : null};
			// when tableheader grouping, we iterate through the grouping's children
			const groupingChildren = [];
			React.Children.forEach(child.props.children, child => {
				if (!layout.columns[columnIndex].visible) {
					// Do nothing here
				} else if (columnIndex === 0 && layout.columns[columnIndex].flex) {
					groupingChildren.push(
						<FirstColumnFlexStyle
							align={layout.columns[columnIndex].align}
							flex={layout.columns[columnIndex].flex}
							zIndex={100}
							width={child.props.width}
						>
							{React.cloneElement(child, {...newProps, wrapped: true, level: 1})}
						</FirstColumnFlexStyle>
					);
				} else if (columnIndex === 0) {
					groupingChildren.push(
						<FirstColumnHeaderStyle width={child.props.width} backgroundColor={backgroundColor}>
							{React.cloneElement(child, {...newProps, wrapped: true, level: 1})}
						</FirstColumnHeaderStyle>
					);
				} else if (layout.columns[columnIndex].flex) {
					groupingChildren.push(
						<FlexColumnStyle
							zIndex={90}
							width={child.props.width}
							backgroundColor={backgroundColor}
							flex={layout.columns[columnIndex].flex}
							align={layout.columns[columnIndex].align}
						>
							{React.cloneElement(child, {...newProps, wrapped: true})}
						</FlexColumnStyle>
					);
				} else {
					groupingChildren.push(React.cloneElement(child, {...newProps}));
				}
				columnIndex++;
			});
			const result = groupingChildren.length === 0 ? null : React.cloneElement(child, {}, groupingChildren);
			return result;
		} else {
			let newProps = {usePadding: true, level: columnIndex === 0 ? 1 : null, groupingWhiteSpace: layout.hasGroupings};
			let newChild = null;
			if (!layout.columns[columnIndex].visible) {
				newChild = null;
			} else if (columnIndex === 0 && layout.columns[columnIndex].flex) {
				newChild = (
					<FirstColumnFlexStyle
						align={layout.columns[columnIndex].align}
						backgroundColor={backgroundColor}
						flex={layout.columns[columnIndex].flex}
						zIndex={100}
						width={child.props.width}
					>
						{React.cloneElement(child, {...newProps, wrapped: true, level: 1})}
					</FirstColumnFlexStyle>
				);
			} else if (columnIndex === 0) {
				newChild = (
					<FirstColumnHeaderStyle
						width={child.props.width}
						backgroundColor={backgroundColor}
						align={layout.columns[columnIndex].align}
					>
						{React.cloneElement(child, {...newProps, wrapped: true, level: 1})}
					</FirstColumnHeaderStyle>
				);
			} else if (layout.columns[columnIndex].flex) {
				newChild = (
					<FlexColumnStyle
						zIndex={90}
						width={child.props.width}
						backgroundColor={backgroundColor}
						flex={layout.columns[columnIndex].flex}
						align={layout.columns[columnIndex].align}
					>
						{React.cloneElement(child, {...newProps, wrapped: true})}
					</FlexColumnStyle>
				);
			} else {
				newChild = React.cloneElement(child, {...newProps});
			}
			columnIndex++;
			return newChild;
		}
	});

	return (
		<TableHeaderStyle useGrouping={layout.hasGroupings} backgroundColor={backgroundColor} stickyOffset={stickyOffset}>
			{newChildren}
		</TableHeaderStyle>
	);
};

TableHeader.propTypes = {
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
	backgroundColor: PropTypes.string,
	stickyOffset: PropTypes.number,
};
